/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.30.0
 */

import { EWizardCollationReportSteps } from '@/main/pages/WizardCollationReport/wizardCollationReportConstant';

import { IWizardCollationReportTranslation } from '../../types/wizards/collationReport';
import { initWizardPropsTranslation } from './initWizardTranslation';

export const initWizardCollationReportTranslation: IWizardCollationReportTranslation = {
    ...initWizardPropsTranslation,
    [EWizardCollationReportSteps.ChooseStep]: {
        chooseParams: '',
        startDateTitle: '',
        endDateTitle: '',
    },
    [EWizardCollationReportSteps.ConfirmStep]: {
        reports: {
            destEmailForLink: '',
            needCompression: '',
            compressionPassword: '',
        },
        summary: {
            params: {
                title: '',
                startDateTitle: '',
                endDateTitle: '',
            },
            notify: {
                title: '',
            },
        },
    },
};
